import React from 'react';
import TimelineClock from './TimelineClock';
import TimelineEvent from './TimelineEvent';
import TimelineEventFoul from './TimelineEventFoul';
import TimelineEventGoal from './TimelineEventGoal';
import TimelineEventOwnGoal from './TimelineEventOwnGoal';
import TimelineEventSubstitution from './TimelineEventSubstitution';
import TimelineEventEndPeriod from './TimelineEventEndPeriod';
import TimelineStart from './TimelineStart';

const COMPONENTS = {
    goal: TimelineEventGoal,
    foul: TimelineEventFoul,
    own_goal: TimelineEventOwnGoal,
    sub_off: TimelineEventSubstitution,
}

export default ({ events, fixture, state, participants, deleteEvent }) => {
    if (fixture && fixture.home_entry) {
        const { isInProgress, startedAt } = state.state;

        if (startedAt) {
            return (
                <div>
                    <ul className="timeline">
                        {isInProgress ? <TimelineClock status={state.state}/> : renderFullTime()}
                        {state.timeline.map(renderEvent)}
                        <TimelineStart startedAt={startedAt}/>
                    </ul>
                </div>
            );
        } else {
            return <div></div>;
        }
    } else {
        return <div></div>;
    }

    function renderEvent(id) {
        const event = events[id] || {};
        const Component = COMPONENTS[event.type];

        if (Component) {
            return (
                <TimelineEvent key={id} fixture={fixture} event={event} state={state}>
                    <Component event={event} participants={participants}/>
                </TimelineEvent>
            );
        } else if (event.type == 'game_endperiod') {
          return (
            <TimelineEventEndPeriod event={event} state={state}/>
          )
        }
    }

    function renderFullTime() {
        return (
            <li className="timeline__item">
                <div className="event event--flow">Full-time</div>
            </li>
        )
    }
};
